import { useSignal } from '@preact/signals'
import { clsx } from 'clsx'
import { getAuth, isSignInWithEmailLink } from 'firebase/auth'
import { useEffect } from 'preact/hooks'
import { getApps } from 'firebase/app'

import {
	Button,
	GithubIcon,
	// GoogleIcon,
	HorizontalDivider,
	Input,
	Typography
} from 'components/UI'
import {
	signInPasswordless,
	signInWithGithub
	//  signInWithGoogle
} from 'state'

import {
	emailState,
	emailFieldErrorState,
	setEmail,
	setEmailFieldError
} from './state'
import { SuccessEmailSent } from './SuccessEmailSent'
import { VerifyEmail } from './VerifyEmail'

const SignIn = () => {
	const signUp = useSignal(false)
	const isSignIn = useSignal(false)
	const signInWasSuccess = useSignal(false)
	const isVerifyEmail = useSignal(false)

	useEffect(() => {
		const isFirebaseInitialized = getApps().length !== 0

		if (isFirebaseInitialized) {
			const auth = getAuth()
			if (isSignInWithEmailLink(auth, window.location.href)) {
				isVerifyEmail.value = true
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const handleSignIn = async (e: Event) => {
		e.preventDefault()
		if (!emailState.value) return

		isSignIn.value = true
		const error = await signInPasswordless(emailState.value)
		isSignIn.value = false

		if (error) {
			// Error is handle by the state, just return
		} else {
			signInWasSuccess.value = true
		}
	}

	// const handleSignInWithGoogle = async () => {
	// 	isSignIn.value = true
	// 	await signInWithGoogle()
	// }

	const handleSignInWithGithub = async () => {
		isSignIn.value = true
		await signInWithGithub()
	}

	const handleEmailValidationInvalidLink = () => {
		isVerifyEmail.value = false
	}

	const restarLogin = () => {
		setEmail('')
		setEmailFieldError('')
		signInWasSuccess.value = false
		isSignIn.value = false
	}

	if (isVerifyEmail.value) {
		return (
			<VerifyEmail
				onEmailValidationInvalidLink={handleEmailValidationInvalidLink}
			/>
		)
	}

	if (signInWasSuccess.value) {
		return (
			<SuccessEmailSent
				buttonLoading={isSignIn.value}
				handleSignIn={handleSignIn}
				restartLogin={restarLogin}
			/>
		)
	}

	return (
		<div class='flex w-[30rem] flex-col space-y-12 rounded-lg border border-black-600 p-6'>
			<Typography
				class='text-center'
				color='text-product'
				text={signUp.value ? 'Create a Código HUB account' : 'Log in/Sign up'}
				variant='h2'
			/>

			<form class='space-y-7' onSubmit={handleSignIn}>
				<Input
					disabled={isSignIn.value}
					error={emailFieldErrorState.value}
					hasError={!!emailFieldErrorState.value}
					helperText='An email will be sent to this address with the crendentials'
					id='email-field'
					label='Email'
					name='email'
					onInput={setEmail}
					placeholder='john.doe@example'
					type='email'
					value={emailState}
				/>
				<div
					class={clsx(
						'flex flex-row items-center space-x-2',
						!signUp.value && 'hidden'
					)}
				>
					<label class='flex flex-row space-x-1' htmlFor='term-field'>
						<input class='mr-1' id='term-field' type='checkbox' />
						<Typography text='I agree to the' variant='text3' />
						<a
							aria-label='Terms and Conditions'
							href='https://codigo.ai/documents/Codigo---Terms-of-Service.pdf'
							rel='noreferrer'
							target='_blank'
						>
							<Typography text='Terms And Conditions' variant='text3' />
						</a>
						<Typography text='and' variant='text3' />
						<a
							aria-label='Privacy Policy'
							href='https://codigo.ai/documents/Codigo---Privacy-Policy.pdf'
							rel='noreferrer'
							target='_blank'
						>
							<Typography text='Privacy Policy' variant='text3' />
						</a>
					</label>
				</div>

				<div>
					<Button
						className='mt-10'
						disabled={
							isSignIn.value ||
							Boolean(emailState.value === '' || emailFieldErrorState.value)
						}
						isLoading={isSignIn.value}
						text={signUp.value ? 'Create my Account' : 'Log In'}
						type='submit'
						fullWidth
					/>
				</div>
			</form>

			<HorizontalDivider />

			<div class='flex flex-row items-center justify-center space-x-2.5'>
				{/* <button
						class={clsx(
							'flex h-[3.5rem] w-full flex-row items-center space-x-4 rounded-lg border border-black-400 bg-transparent px-5 py-2.5 hover:bg-black-800 '
						)}
						onClick={handleSignInWithGoogle}
						type='button'
					>
						<GoogleIcon />
						<Typography text='Google' variant='label3' />
					</button> */}

				<button
					aria-label='Log in with GitHub'
					class={clsx(
						'relative flex h-[3.5rem] w-full flex-row items-center justify-center space-x-4 rounded-lg border border-black-400 bg-transparent px-5 py-2.5 text-center hover:bg-black-800'
					)}
					onClick={handleSignInWithGithub}
					type='button'
				>
					<GithubIcon className='absolute left-5' />
					<Typography text='Log in with GitHub' variant='label3' />
				</button>
			</div>
		</div>
	)
}

export { SignIn }
